import React from "react";
import { Box, IconButton, Tooltip } from "@mui/material";
import EditRoundedIcon from "@mui/icons-material/EditRounded";
import DeleteOutlineRoundedIcon from "@mui/icons-material/DeleteOutlineRounded";

export default function GeoMasterActionCell({ onEdit, onDelete, editTitle = "Update", deleteTitle = "Delete" }) {
  return (
    <Box sx={{ display: "flex", alignItems: "center", gap: 0.25 }}>
      <Tooltip title={editTitle}>
        <IconButton size="small" color="primary" onClick={onEdit} aria-label={editTitle}>
          <EditRoundedIcon fontSize="small" />
        </IconButton>
      </Tooltip>
      <Tooltip title={deleteTitle}>
        <IconButton size="small" color="error" onClick={onDelete} aria-label={deleteTitle}>
          <DeleteOutlineRoundedIcon fontSize="small" />
        </IconButton>
      </Tooltip>
    </Box>
  );
}
